import request from '@/utils/request'

/**
 * 获取终端
 */
function getcarList(data){
  return request({
    url: '/car/list',
    method: 'post',
    data
  })
}
/**
 * 获取终端
 */
function gettboxList(data){
  return request({
    url: '/lockCar/list',
    method: 'post',
    data
  })
}
/**
 * 获取座位数-配置-颜色
 * 
 */
function getCarConfiguer() {
    return request({
      url: '/common/model',
      method: 'get'       
    })
  }
  /**
 * 获取地区
 * 
 */
function getCarArea() {
    return request({
      url: '/common/area',
      method: 'get'   
    })
  }
function getFuels() {
  return request({
    url: '/common/fuelType',
    method: 'get'
  })
}
   /**
 * 获取车辆绑定历史
 * 
 */
function getCarHistory(id) {
  return request({
    url: `/car/bind/list/${id}`,
    method: 'get'   
  })
} 
/**
 * 解绑OBD
 * id为车辆id
 * data为barCode,string类型 必须 OBD设备号	
         sim	   string	    非必须
 * 
 */
function untyOBD(id,params) {
  return request({
    url: `/car/unbind/${id}`,
    method: 'DELETE',
    params   
  })
} 
/**
 * 绑定OBD
 * 
 */
function bindOBD(data,id) {
  return request({
    url: `/car/bind/${id}`,
    method: 'put',
    data   
  })
}  

/**
 * 获取车辆绑定终端
 */
function getCarToTerminal(data) {
  return request({
    url: '/terminal/unbind/list',
    method: 'post',
    data
  })
}

/**
 * 导出车辆列表
 * 
 */
function exportCar(data) {
  return request({
    url: '/car/export',
    method: 'POST',
    responseType: 'arraybuffer',
    data   
  })
} 

/**
 * 解锁/闭锁
 */
function isVerification(pwd) {
	return request({
		url: `/lockCar/${pwd}`,
		method: "post",
	});
}
export {
	getcarList,
	gettboxList,
	getCarConfiguer,
	getCarArea,
	getCarHistory,
	untyOBD,
	bindOBD,
	getCarToTerminal,
	exportCar,
	getFuels,
	isVerification,
};